import { NAME as DOMAIN_NAME } from '../constants';

export const NAME = `${DOMAIN_NAME}/PAYABLES`;
export const REDUCER_NAME = 'payables';

export const APIS = {
  GET_STATEMENTS: `${OPERATIONS_EDGE}/api/statements`,
  MARK_PAID: `${OPERATIONS_EDGE}/api/statements/markpaid`,
};

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/reconciliation`;

export const STATEMENT_STATUS = {
  OPEN: 'OPEN',
  PAID: 'PAID',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
};

export const ROUTES = {
  ROOT: '/finance/payables',
};

export const STATUS_COLORS = {
  OPEN: '#e03b24',
  PAID: '#64a338',
  PARTIALLY_PAID: '#ffcc00',
};
